import React, { PureComponent } from 'react';

import './CustomJewelryPage.style';
import CmsPage from '@scandipwa/scandipwa/src/route/CmsPage';
import CustomJewelryForm from './CustomJewelryPage.type';
import FieldGroup from '@scandipwa/scandipwa/src/component/FieldGroup';
import Field from '@scandipwa/scandipwa/src/component/Field';
import Form from '@scandipwa/scandipwa/src/component/Form';
import Loader from '@scandipwa/scandipwa/src/component/Loader';

export class CustomJewelryPageComponent extends PureComponent {
    static propTypes = {
        currentUrl: this.propTypes,
        match: this.propTypes,
        onFormSubmit: this.propTypes,
        isLoading: this.propTypes
    };

    getFormProps() {
        const { onFormSubmit } = this.props;

        return {
            onSubmit: onFormSubmit,
        };
    }

    fieldMap() {
        return CustomJewelryForm();
    }

    renderActions() {
        const { isLoading } = this.props;

        return (
            <>
                <Loader isLoading={isLoading} />
                <button type="submit" className="Button">
                    Submit custom inquiry
                </button>
            </>
        );
    }

    renderSection(section) {
        if ('fields' in section) {
            const { name: sectionName, attr: { name } = {}, fields } = section;

            return (
                <FieldGroup {...section} key={name || sectionName}>
                    {fields.map(this.renderSection.bind(this))}
                </FieldGroup>
            );
        }

        const { attr: { name } = {} } = section;

        return <Field {...section} key={name} />;
    }

    renderFormBody() {
        return (
            <div className="FieldForm-Body">
                <div className="FieldForm-Fields">
                    {this.fieldMap().map(this.renderSection.bind(this))}
                </div>
                {this.renderActions()}
            </div>
        );
    }

    render() {
        const { match, currentUrl } = this.props;

        return (
            <div className="CustomJewelryPage">
                <CmsPage match={match} currentUrl={currentUrl} pageIdentifiers={'custom-jewelry'} />

                <div className="CustomJewelryPage-Divider"></div>

                <section className='CustomJewelryPage-JewelryInquiry'>
                    <h1 className="CustomJewelryPage-Titles">custom jewelry inquiry</h1>

                    <div className='CustomJewelryPage-InquiryForm'>
                        <Form {...this.getFormProps()} className="FieldForm">
                            {this.renderFormBody()}
                        </Form>
                    </div>
                </section>
            </div>
        );
    }
}

export default CustomJewelryPageComponent;
